import React, { useEffect, useState } from 'react';
import Button from '../../UI/button/button';
import WrapperDefault from '../../UI/wrapper-default/wrapper-default';

function ErrorComponent({
  retryFunction,
  textError = 'Houve algum erro',
  textButton = 'Tentar novamente',
  retryTimeout,
  description,
}) {
  const [timeToRetry, setTimeToRetry] = useState(retryTimeout);

  useEffect(() => {
    if (retryTimeout) {
      const timeInterval = setInterval(() => {
        setTimeToRetry((prevState) => {
          const nextValue = prevState - 1;

          if (nextValue == 0) {
            clearInterval(timeInterval);
            return undefined;
          }

          return nextValue;
        });
      }, 1000);
    }
  }, [retryTimeout]);

  return (
    <WrapperDefault style={{ textAlign: 'center', marginTop: 100 }}>
      <h1>{textError}</h1>
      <p>{description}</p>
      {retryFunction && (
        <div className="mt-5">
          <Button onClick={retryFunction} disabled={timeToRetry} rounded>
            {timeToRetry ? `Tentar novamente em ${timeToRetry}` : textButton}
          </Button>
        </div>
      )}
    </WrapperDefault>
  );
}

export default function ErrorDisplay({ hasError, children, ...props }) {
  return hasError ? <ErrorComponent {...props} /> : children;
}
